module.exports = __webpack_public_path__ + "img/rl-hub-600w.84fa91a5.jpg";